module.exports = Jsw.skinUrl + "/images/AI.svg?a324fb5e0ae229cedae9ad21e4a40294";